import type { IUserInfoResult } from '../interfaces/user';

export const CHECK_EMAIL_MOCK_RESPONSE = () =>
  Promise.resolve({
    data: {
      verified: true
    }
  });

export const USER_INFO_MOCK: IUserInfoResult = {
  id: 'mock-user-id',
  name: 'John',
  lastName: 'Doe',
  secondLastName: null,
  email: 'john.doe@company.com',
  locale: 'es',
  countryCode: 'CL',
  documentType: 'RUT',
  documentValue: '12345678-9',
  phoneNumber: '+56912345678',
  brokers: [
    {
      brokerId: 'broker-001',
      name: 'Mock Broker',
      role: 'admin',
      contactRoleStatus: 'active'
    }
  ]
};

export const GET_USER_INFO_MOCK_RESPONSE = () =>
  Promise.resolve({
    data: USER_INFO_MOCK
  });

export const GET_INTERCOM_TOKEN_MOCK_RESPONSE = () =>
  Promise.resolve({
    data: { token: 'mock-intercom-jwt-token' }
  });
